import React from "react";
import { Box, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";

export default function DateRangeSelector({
  selectDay,
  setSelectDay,
  selectWeek,
  setSelectWeek,
  selectMonth,
  setSelectMonth,
  dateRange,
  setDateRange,
  day,
  week,
  month,
}) {
  return (
    <Box sx={{ display: "flex", gap: 1 }}>
      <FormControl sx={{ width: "60px" }}>
        <InputLabel
          id="day-select-label"
          sx={{
            color: "var(--text-color)",
            "&.Mui-focused": {
              color: "var(--text-color)",
            },
          }}
        >
          일
        </InputLabel>
        <Select
          labelId="day-select-label"
          label="일"
          value={selectDay}
          onChange={(e) => {
            setSelectDay(e.target.value);
            setSelectWeek("");
            setSelectMonth("");
          }}
          sx={{
            color: "var(--text-color)",
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: "var(--line-text-color)",
            },
          }}
          MenuProps={{
            PaperProps: {
              sx: {
                backgroundColor: "var(--bg-color)",
                color: "var(--text-color)",
                border: "1px solid var(--border-line-color)",
              },
            },
          }}
        >
          {day.map((d) => (
            <MenuItem key={d} value={`${d} DAY`}>
              {d}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl sx={{ width: "60px" }}>
        <InputLabel
          id="week-select-label"
          sx={{
            color: "var(--text-color)",
            "&.Mui-focused": {
              color: "var(--text-color)",
            },
          }}
        >
          주
        </InputLabel>
        <Select
          labelId="week-select-label"
          label="주"
          value={selectWeek}
          onChange={(e) => {
            setSelectWeek(e.target.value);
            setSelectDay("");
            setSelectMonth("");
          }}
          sx={{
            color: "var(--text-color)",
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: "var(--line-text-color)",
            },
          }}
          MenuProps={{
            PaperProps: {
              sx: {
                backgroundColor: "var(--bg-color)",
                color: "var(--text-color)",
                border: "1px solid var(--border-line-color)",
              },
            },
          }}
        >
          {week.map((w) => (
            <MenuItem key={w} value={`${w} WEEK`}>
              {w}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl sx={{ width: "60px" }}>
        <InputLabel
          id="month-select-label"
          sx={{
            color: "var(--text-color)",
            "&.Mui-focused": {
              color: "var(--text-color)",
            },
          }}
        >
          월
        </InputLabel>
        <Select
          labelId="month-select-label"
          label="달"
          value={selectMonth}
          onChange={(e) => {
            setSelectMonth(e.target.value);
            setSelectDay("");
            setSelectWeek("");
          }}
          sx={{
            color: "var(--text-color)",
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: "var(--line-text-color)",
            },
          }}
          MenuProps={{
            PaperProps: {
              sx: {
                backgroundColor: "var(--bg-color)",
                color: "var(--text-color)",
                border: "1px solid var(--border-line-color)",
              },
            },
          }}
        >
          {month.map((m) => (
            <MenuItem key={m} value={`${m} MONTH`}>
              {m}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <DatePicker
        label="시작일"
        disableFuture
        value={dayjs(dateRange.start)}
        slotProps={{
          textField: {
            error: false,
            variant: "outlined",
            sx: {
              color: "var(--text-color)",
              "& label": {
                color: "var(--text-color)",
              },
              "& label.Mui-focused": {
                color: "var(--text-color)",
              },
              "& .MuiInputBase-input": {
                color: "var(--text-color)",
              },
              "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
                borderColor: "var(--border-line-color)",
              },
              "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                {
                  borderColor: "var(--line-text-color)",
                },
              "& .MuiOutlinedInput-root.Mui-focused": {
                color: "var(--text-color)",
              },
            },
          },
          openPickerIcon: {
            sx: {
              color: "var(--text-color)",
            },
          },
          popper: {
            sx: {
              "& .MuiPaper-root": {
                backgroundColor: "var(--hover-bg-color)",
                color: "var(--text-color)",
                border: "1px solid var(--border-line-color)",
              },
            },
          },
        }}
        onChange={(newValue) => {
          setDateRange((prev) => ({
            ...prev,
            start: newValue.format("YYYY-MM-DD"),
          }));
          setSelectDay("");
          setSelectWeek("");
          setSelectMonth("");
        }}
        format="YYYY-MM-DD"
        sx={{
          "& .MuiOutlinedInput-root": {
            width: "170px",
          },
          "& .MuiInputBase-input": {
            color: "var(--text-color)",
          },
          "& .MuiInputLabel-root": {
            color: "var(--text-color)",
          },
        }}
      />

      <DatePicker
        label="종료일"
        disableFuture
        value={dayjs(dateRange.end)}
        slotProps={{
          textField: {
            error: false,
            variant: "outlined",
            sx: {
              color: "var(--text-color)",
              "& label": {
                color: "var(--text-color)",
              },
              "& label.Mui-focused": {
                color: "var(--text-color)",
              },
              "& .MuiInputBase-input": {
                color: "var(--text-color)",
              },
              "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
                borderColor: "var(--border-line-color)",
              },
              "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                {
                  borderColor: "var(--line-text-color)",
                },
              "& .MuiOutlinedInput-root.Mui-focused": {
                color: "var(--text-color)",
              },
            },
          },
          openPickerIcon: {
            sx: {
              color: "var(--text-color)",
            },
          },
          popper: {
            sx: {
              "& .MuiPaper-root": {
                backgroundColor: "var(--hover-bg-color)",
                color: "var(--text-color)",
                border: "1px solid var(--border-line-color)",
              },
            },
          },
        }}
        onChange={(newValue) => {
          setDateRange((prev) => ({
            ...prev,
            end: newValue.format("YYYY-MM-DD"),
          }));
          setSelectDay("");
          setSelectWeek("");
          setSelectMonth("");
        }}
        format="YYYY-MM-DD"
        sx={{
          "& .MuiOutlinedInput-root": {
            width: "170px",
          },
          "& .MuiInputBase-input": {
            color: "var(--text-color)",
          },
          "& .MuiInputLabel-root": {
            color: "var(--text-color)",
          },
        }}
      />
    </Box>
  );
}
